import React, {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useRef,
} from 'react';

type AudioPlayerGroupContextValue = {
  registerPlay: (pause: () => void) => void;
};

const AudioPlayerGroupContext =
  createContext<AudioPlayerGroupContextValue | null>(null);

export const useAudioPlayerGroup = () => useContext(AudioPlayerGroupContext);

export const AudioPlayerGroup: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const activePauseRef = useRef<(() => void) | null>(null);

  const registerPlay = useCallback((pause: () => void) => {
    if (activePauseRef.current && activePauseRef.current !== pause) {
      activePauseRef.current();
    }
    activePauseRef.current = pause;
  }, []);

  const value = useMemo(() => ({ registerPlay }), [registerPlay]);

  return (
    <AudioPlayerGroupContext.Provider value={value}>
      {children}
    </AudioPlayerGroupContext.Provider>
  );
};
